import * as React from "react";
import type { SVGProps } from "react";

interface ExtraPointProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const ExtraPoint = ({ cancelled = false, ...props }: ExtraPointProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none">
      <path
        fill="#000"
        fillRule="evenodd"
        stroke="#FFF"
        d="M2.18.75a.93.93 0 0 1 .94.93v7.07h6.8V1.68c0-.23.08-.44.22-.6 1.02-.44 1.18-.22 1.33-.09.2.18.31.42.31.7v8a.93.93 0 0 1-.93.93H7.58v3.73a.9.9 0 0 1-.32.68.98.98 0 0 1-.68.25c-.26 0-.5-.1-.68-.25a.9.9 0 0 1-.32-.68v-3.73h-3.4a.93.93 0 0 1-.93-.94v-8a.93.93 0 0 1 .93-.93Z"
      />
      <path
        stroke="#000"
        strokeWidth={0.25}
        d="M2.18 1.13a.56.56 0 0 1 .56.55v7.45h7.55V1.67c.14-.37.15-.38.16-.39h.03c.51-.2.64-.1.74-.01.12.1.19.24.19.4v8a.56.56 0 0 1-.56.56H7.21v4.11c0 .16-.07.3-.2.4a.66.66 0 0 1-.43.16.66.66 0 0 1-.43-.16.53.53 0 0 1-.2-.4v-4.1H2.19a.56.56 0 0 1-.56-.57v-8a.56.56 0 0 1 .56-.55Z"
      />
      <path
        fill="#FFF"
        d="M15.76 8.25a7.5 7.5 0 1 0 0 15.02 7.5 7.5 0 0 0 0-15.02"
      />
      <path
        fill="#007BBD"
        d="M15.76 8.98a6.78 6.78 0 1 1 0 13.56 6.78 6.78 0 0 1 0-13.56"
      />
      <path
        fill="#FFF"
        d="M18.73 19.63c-.42 0-.63-.23-.63-.68v-5.87l-.83.54c-.39.27-.7.22-.91-.14q-.33-.525.24-.9l1.4-.86a1.54 1.54 0 0 1 .86-.24c.33 0 .49.23.49.69v6.78c0 .45-.2.68-.62.68m-5.07-5.49c.25 0 .45.22.45.49v1.48h1.49c.26 0 .48.2.48.46 0 .25-.22.45-.48.45h-1.5v1.48c0 .27-.2.49-.45.49s-.46-.22-.46-.49v-1.48h-1.48c-.27 0-.48-.2-.48-.45 0-.26.21-.46.48-.46h1.48v-1.48c0-.27.2-.49.46-.49Z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default ExtraPoint;
